import { render, staticRenderFns } from "./PowAttr.vue?vue&type=template&id=75caed7f&"
import script from "./PowAttr.vue?vue&type=script&lang=js&"
export * from "./PowAttr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports